<template>
<div>
  <table class="table table-striped d-none d-md-table">
    <thead>
      <tr>
        <th scope="col">Typ</th>
        <th scope="col">Adres budynku</th>
        <th scope="col">Data utworzenia</th>
        <th scope="col">Data ostatniej modyfikacji</th>
        <th scope="col">Status deklaracji</th>
        <th scope="col">Akcje</th>
      </tr>
    </thead>
    <tbody>
    <tr v-for="declaration in declarations" :key="declaration.id">
      <td>{{ declaration.type | toPolish }}</td>
      <td>{{ declaration.building.formatted_address }}</td>
      <td>{{ declaration.created_at }}</td>
      <td>{{ declaration.updated_at }}</td>
      <td>
        {{ declaration.status | statusToPolish }}
        <div class="submit-date" v-if="(declaration.status === 'SUBMITTED') || (declaration.status === 'EDITED')">{{ declaration.submitted_at }}</div>
      </td>
      <td>
        <b-dropdown
          size="lg"
          variant="link"
          toggle-class="text-decoration-none"
          no-caret right
        >
          <template #button-content>
            <b-icon-three-dots-vertical/>
            <span class="sr-only">User</span>
          </template>
          <b-dropdown-item
            href="#"
            v-if="declaration.status !== 'SUBMITTED'"
            @click="$emit('submit-declaration', {declarationId: declaration.id, declarationType: declaration.type, hasStatement: declaration.has_statement})"
          >
            Złóż
          </b-dropdown-item>
          <b-dropdown-item
            v-if="declaration.status !== 'SUBMITTED'"
            href="#"
            @click="editDeclaration(declaration.building, declaration.id, declaration.type)"
          >
            Edytuj
          </b-dropdown-item>
          <b-dropdown-item
            v-if="(declaration.status === 'SUBMITTED') && (declaration.editable)"
            href="#"
            @click="editSubmittedDeclaration(declaration.building, declaration.id, declaration.type)"
          >
            Edytuj
          </b-dropdown-item>
          <b-dropdown-item
            v-if="(declaration.status === 'SUBMITTED') && (declaration.edited)"
            href="#"
            @click="showHistory(declaration.id)"
          >
            Pokaż historię
          </b-dropdown-item>
          <b-dropdown-item :href="`/api/declarations/pdf/${declaration.id}`" target="_blank">Pobierz PDF</b-dropdown-item>
          <b-dropdown-item :href="`/api/declarations/pdf/${declaration.id}?mode=preview`" target="_blank">Podgląd PDF</b-dropdown-item>
          <b-dropdown-item
            href="#"
            @click="cloneDeclaration(declaration.id)"
          >
            Powiel deklarację do nowego budynku
          </b-dropdown-item>
          <b-dropdown-item
            v-if="declaration.editable"
            href="#"
            @click="moveDeclaration(declaration.id)"
          >
            Przenieś deklarację do innego budynku
          </b-dropdown-item>
          <b-dropdown-item
            v-if="declaration.status !== 'SUBMITTED'"
            href="#"
            @click="$emit('delete-declaration', declaration.id)"
          >
            Usuń
          </b-dropdown-item>
        </b-dropdown>
      </td>
    </tr>
    </tbody>
  </table>

  <table class="table table-striped d-table d-md-none">
    <thead>
      <tr>
        <th scope="col">Deklaracja</th>
        <th scope="col">Akcje</th>
      </tr>
    </thead>
    <tbody>
    <tr v-for="declaration in declarations" :key="declaration.id">
      <td>
        Typ: {{ declaration.type | toPolish }}<br />
        Adres: {{ declaration.building.formatted_address }}<br />
        Status: {{ declaration.status | statusToPolish }}
      </td>
      <td>
        <b-dropdown
          size="lg"
          variant="link"
          toggle-class="text-decoration-none"
          no-caret right
        >
          <template #button-content>
            <b-icon-three-dots-vertical/>
            <span class="sr-only">User</span>
          </template>
          <b-dropdown-item
            href="#"
            v-if="declaration.status !== 'SUBMITTED'"
            @click="$emit('submit-declaration', {declarationId: declaration.id, declarationType: declaration.type})"
          >
            Złóż
          </b-dropdown-item>
          <b-dropdown-item
            v-if="declaration.status !== 'SUBMITTED'"
            href="#"
            @click="editDeclaration(declaration.building, declaration.id, declaration.type)"
          >
            Edytuj
          </b-dropdown-item>
          <b-dropdown-item
            v-if="(declaration.status === 'SUBMITTED') && (declaration.editable)"
            href="#"
            @click="editSubmittedDeclaration(declaration.building, declaration.id, declaration.type)"
          >
            Edytuj
          </b-dropdown-item>
          <b-dropdown-item :href="`/api/declarations/pdf/${declaration.id}`" target="_blank">Pobierz PDF
          </b-dropdown-item>
          <b-dropdown-item
            v-if="(declaration.status === 'SUBMITTED') && (declaration.edited)"
            href="#"
            @click="showHistory(declaration.id)"
          >
            Pokaż historię
          </b-dropdown-item>
          <b-dropdown-item
            v-if="declaration.status !== 'SUBMITTED'"
            href="#"
            @click="$emit('delete-declaration', declaration.id)"
          >
            Usuń
          </b-dropdown-item>
        </b-dropdown>
      </td>
    </tr>
    </tbody>
  </table>
</div>
</template>

<script>
import DeclarationsModel from "@/models/declarations";

export default {
  name: "ByBuildingList",
  props: ["declarations"],
  components: {DeclarationsModel},
  methods: {
    editDeclaration(buildingData, declarationId, declarationType) {
      buildingData.declarationType = declarationType;
      this.$store.commit("setDeclarationBuilding", buildingData);
      this.$store.commit("setDeclarationEditId", declarationId);
      this.$store.commit("openDeclarationModal");
    },
    editSubmittedDeclaration(buildingData, declarationId, declarationType) {
      DeclarationsModel.createEditedDeclaration(declarationId)
        .then((res) => {
          if (res.data.status === "ok") {
            const editedId = res.data.declarationId;
            buildingData.declarationType = declarationType;
            this.$store.commit("setDeclarationBuilding", buildingData);
            this.$store.commit("setDeclarationEditId", editedId);
            this.$store.commit("openDeclarationModal");
          }
        });
    },
    showHistory(declarationId) {
      this.$store.commit("setDeclarationHistoryId", declarationId);
      this.$store.commit("openHistoryModal");
    },
    cloneDeclaration(declarationId) {
      this.$store.commit("setClonedDeclarationId", declarationId);
      this.$store.commit("openCloneDeclarationModal");
    },
    moveDeclaration(declarationId) {
      this.$store.commit("setMovedDeclarationId", declarationId);
      this.$store.commit("openMoveDeclarationModal");
    }
  },
  filters: {
    toPolish(value) {
      if (!value) return ''
      value = value.toString()
      return value.charAt(0).toUpperCase() + value.slice(1)
    },
    statusToPolish(status) {
      return {
        "DRAFT": 'Wersja robocza',
        "SUBMITTED": 'Złożona',
        "EDITED": 'Złożona w edycji',
      }[status];
    }
  }
}
</script>

<style scoped>
.submit-date { font-size: small }
</style>
